export const normalizeAcaCode = (value) => String(value || '').trim().toUpperCase();

export const normalizeChatAcaCode = (value) => {
  const normalizedAcaCode = normalizeAcaCode(value);
  const numericSuffix = normalizedAcaCode.match(/(\d+)$/)?.[1];
  return numericSuffix || normalizedAcaCode;
};

export const normalizeChatUserId = (rawId, acaCode) => {
  const trimmedId = String(rawId || '').trim();
  if (!trimmedId) return '';

  const normalizedAcaCode = normalizeAcaCode(acaCode);
  if (normalizedAcaCode) {
    const chatAcaCode = normalizeChatAcaCode(normalizedAcaCode);
    const acaPrefixes = [...new Set([normalizedAcaCode, chatAcaCode])]
      .sort((a, b) => b.length - a.length)
      .map((code) => `${code}_`);
    let userIdBody = trimmedId;

    // FD2001과 2001을 같은 학원 접두어로 보고, 과거에 중복된 접두어도 한 번으로 정리한다.
    let matchedPrefix = acaPrefixes.find((prefix) => userIdBody.toUpperCase().startsWith(prefix));
    while (matchedPrefix) {
      userIdBody = userIdBody.slice(matchedPrefix.length);
      matchedPrefix = acaPrefixes.find((prefix) => userIdBody.toUpperCase().startsWith(prefix));
    }

    const isGuardianId = /^P_/i.test(userIdBody);
    const userAcaCode = isGuardianId ? chatAcaCode : normalizedAcaCode;
    return userIdBody ? `${userAcaCode}_${userIdBody}` : userAcaCode;
  }

  const separatorIndex = trimmedId.indexOf('_');
  if (separatorIndex > 0) {
    const idAcaCode = trimmedId.slice(0, separatorIndex);
    if (/^(?:[A-Za-z]+\d+|\d+)$/.test(idAcaCode)) {
      const userIdBody = trimmedId.slice(separatorIndex + 1);
      const userAcaCode = /^P_/i.test(userIdBody)
        ? normalizeChatAcaCode(idAcaCode)
        : normalizeAcaCode(idAcaCode);
      return `${userAcaCode}_${userIdBody}`;
    }
  }

  return trimmedId;
};
